module.exports = __webpack_public_path__ + "73a7c7d3.png";